import React from 'react';
import type { WidgetRow } from 'App/components/hooks/integrations/externalIntegrationTypes';
import { Flex, Select, Text } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import './ClickSetting.scss';
import BemClass from '@upsales/components/Utils/bemClass';
import WidgetFieldSetting from './WidgetFieldSetting';
import { useExternalIntegrationSelector } from 'App/components/hooks/integrations/ExternalIntegrationModal/ExternalIntegrationContext';

export type ClickSettingProps = {
	row: WidgetRow;
	onChange: (clickAction: string, clickSettings: Record<string, any>) => void;
};

const ClickSetting = ({ row, onChange }: ClickSettingProps) => {
	const classes = new BemClass('ClickSetting');
	const { t } = useTranslation();
	const click = row.settings?.click;
	const clickSettings = row.settings?.clickSettings;
	const widgets = useExternalIntegrationSelector(state => state.widgets);

	const options = [
		{ id: 'Create', title: t('default.create') },
		{ id: 'CloseModal', title: t('default.closeModal') },
		{ id: 'Modal', title: t('default.modal') },
		{ id: 'Navigate', title: t('default.navigateTo') },
		{ id: 'Reload', title: t('default.reload') },
		{ id: 'Widget', title: t('default.widget') },
		{ id: 'Save', title: t('default.save') }
	];

	const selectedOption = options.find(option => option.id === click);

	const optionsWithWidgetSelector = ['Widget', 'Modal'];

	const widgetOptions =
		widgets?.map(widget => ({
			id: widget.id.toString(),
			title: widget.name
		})) || [];
	const selectedWidgetOption = clickSettings?.widget
		? widgetOptions.find(option => option.id === clickSettings.widget)
		: undefined;

	return (
		<Flex direction="column" gap="u2" className={classes.b()} space="ptm">
			<Text>{t('default.onClick')}</Text>
			<Select
				anchor=".Modals"
				value={selectedOption || null}
				options={options}
				onChange={item => onChange(item?.id || '', clickSettings)}
			/>

			{optionsWithWidgetSelector.includes(click) ? (
				<WidgetFieldSetting text={t('default.widget')}>
					<Select
						anchor=".Modals"
						value={selectedWidgetOption || null}
						options={widgetOptions}
						onChange={item => onChange(click, { ...clickSettings, widget: item?.id })}
					/>
				</WidgetFieldSetting>
			) : null}
		</Flex>
	);
};

export default ClickSetting;
